// extracted by mini-css-extract-plugin
export default {"custom-pill":"itemListFilter_custom-pill__ONFWc"};